<script>
  import MissionPage from '$lib/pages/MissionPage.svelte';
</script>

<MissionPage />

